import { Project } from "../types/dashboard.types";

export function toProjectFromSites(s: any): Project {
    return {
        id: String(s.id),
        slug: s.slug,
        thumbnailUrl: s.thumbnailUrl,
        projectName: s.projectName,
        templateId: s.templateId,
        latestVersionId: s.latestVersionId ?? null,
        status: "publish",
        createdAt: s.createdAt,
        updatedAt: s.updatedAt,
    };
}

export function toProjectFromDrafts(d: any): Project {
    return {
        id: String(d.id),
        slug: d.slug,
        thumbnailUrl: d.thumbnailUrl,
        projectName: d.projectName,
        templateId: d.templateId,
        status: "draft",
        createdAt: d.createdAt,
        updatedAt: d.updatedAt,
    };
}

export function mergeProjects(localDrafts: Project[], backend: Project[]): Project[] {
    const map = new Map<string, Project>();

    for (const d of localDrafts) map.set(d.id, d);
    for (const p of backend) map.set(p.id, p);

    return Array.from(map.values()).sort(
        (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime(),
    );
}